// extracted by mini-css-extract-plugin
export default {"contact-card":"styles_contact-card__UOiim","icon":"styles_icon__3flHh","social-media":"styles_social-media__9tQ9z"};